import { DateTime } from 'luxon';

export const DATES = {
	TODAY: 'Today',
	YESTERDAY: 'Yesterday',
	LAST_7_DAYS: 'Last 7 days',
	LAST_30_DAYS: 'Last 30 days',
	THIS_MONTH: 'This month',
	LAST_MONTH: 'Last month',
	THIS_QUARTER: 'This quarter',
	LAST_QUARTER: 'Last quarter',
	THIS_YEAR: 'This Year',
	LAST_YEAR: 'Last Year',
	CUSTOM_RANGE: 'Custom range',
};

export const DATES_ID = {
	TODAY: 'today',
	YESTERDAY: 'yesterday',
	LAST_7_DAYS: 'last_7_days',
	LAST_30_DAYS: 'last_30_days',
	THIS_MONTH: 'this_month',
	LAST_MONTH: 'last_month',
	THIS_QUARTER: 'this_quarter',
	LAST_QUARTER: 'last_quarter',
	THIS_YEAR: 'this_year',
	LAST_YEAR: 'last_year',
	CUSTOM_RANGE: 'custom_range',
};

export const DATES_ARRAY = [
	{
		label: DATES.TODAY,
		id: DATES_ID.TODAY,
		from: DateTime.now().toISODate(),
		periodOfTime: 'day',
	},
	{
		label: DATES.YESTERDAY,
		id: DATES_ID.YESTERDAY,
		from: DateTime.now().minus({ days: 1 }).toISODate(),
		to: DateTime.now().toISODate(),
		periodOfTime: 'day',
	},
	{
		label: DATES.LAST_7_DAYS,
		id: DATES_ID.LAST_7_DAYS,
		from: DateTime.now().minus({ days: 7 }).toISODate(),
		periodOfTime: 'last',
	},
	{
		label: DATES.LAST_30_DAYS,
		id: DATES_ID.LAST_30_DAYS,
		from: DateTime.now().minus({ days: 30 }).toISODate(),
		periodOfTime: 'last',
	},
	{
		label: DATES.THIS_MONTH,
		id: DATES_ID.THIS_MONTH,
		from: DateTime.now().startOf('month').toISODate(),
		periodOfTime: 'last',
	},
	{
		label: DATES.LAST_MONTH,
		id: DATES_ID.LAST_MONTH,
		from: DateTime.now().minus({ months: 1 }).startOf('month').toISODate(),
		to: DateTime.now().startOf('month').toISODate(),
		periodOfTime: 'period',
	},
	{
		label: DATES.THIS_QUARTER,
		id: DATES_ID.THIS_QUARTER,
		from: DateTime.now().startOf('quarter').toISODate(),
		periodOfTime: 'last',
	},
	{
		label: DATES.LAST_QUARTER,
		id: DATES_ID.LAST_QUARTER,
		from: DateTime.now().minus({ quarters: 1 }).startOf('quarter').toISODate(),
		to: DateTime.now().startOf('quarter').toISODate(),
		periodOfTime: 'period',
	},
	{
		label: DATES.THIS_YEAR,
		id: DATES_ID.THIS_YEAR,
		from: DateTime.now().startOf('year').toISODate(),
		periodOfTime: 'last',
	},
	{
		label: DATES.LAST_YEAR,
		id: DATES_ID.LAST_YEAR,
		from: DateTime.now().minus({ years: 1 }).startOf('year').toISODate(),
		to: DateTime.now().startOf('year').toISODate(),
		periodOfTime: 'period',
	},
	// {
	// 	label: DATES.CUSTOM_RANGE,
	// 	id: DATES_ID.CUSTOM_RANGE,
	// },
];
